import {
  base_colorAlert,
  base_colorAlertHover,
  base_colorContentBorder,
  base_contentHover,
  tag_colorTagNewBackground,
  tag_colorTagNewText,
  tag_colorTagNewTextHover,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import {
  cornerRadius,
  flyout_outerBlockVSpacing,
  spacing,
} from 'ext-ui/style/spacing'
import { fontRegular } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${flyout_outerBlockVSpacing};
  position: relative;

  .details {
    display: flex;
    flex-direction: row;
    gap: ${spacing(2)};
    align-items: center;
    ${fontRegular}
    color: ${text_colorTextPrimary};

    .transaction-card-name {
      display: block;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    & > *:not(:first-child) {
      display: flex;
      gap: ${spacing(2)};
      align-items: center;

      ::before {
        content: '•';
        color: ${text_colorTextSecondary};
        ${fontRegular};
      }
    }
  }

  .decline-reason {
    color: ${base_colorAlert};
    display: block;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .timeline {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 18px; // Center of 36px diameter icons
      width: 1px;
      // Expecting that this timeline list will eventually have
      // a variable number of timeline-events in it, so making
      // the height 100% of the parent .timeline container with
      // slight adjustment to account for the icon not being the
      // full height of the timeline-event row, and the row's v padding
      height: calc(100% - 6px);
      background-color: ${base_colorContentBorder};
    }

    .timeline-event {
      display: flex;
      align-items: flex-start;
      gap: ${spacing(3)};
      position: relative;
    }
  }

  .feedback-button {
    &:hover g {
      fill: transparent;
    }
    &.negative {
      color: ${base_colorAlert};

      &:hover {
        color: ${base_colorAlertHover};
      }
    }
  }

  .expense-policy-ai-banner {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: ${spacing(3)};
    padding: ${spacing(4)} ${spacing(5)};
    border: 1px solid ${base_colorContentBorder};
    border-radius: ${cornerRadius};
    background-color: ${tag_colorTagNewBackground};
  }

  .policy-insight-icon {
    display: flex;
    flex-shrink: 0;
  }

  .policy-insight-body {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: ${spacing(2)};
    min-width: 0;
  }

  .policy-insight-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${spacing(4)};
    min-height: ${spacing(8)};
  }

  .policy-insight-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing(2)};
    color: ${text_colorTextPrimary};
  }

  .policy-insight-text {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
  }

  .policy-insight-text-line {
    display: block;
  }

  .policy-feedback-actions {
    display: flex;
    flex-shrink: 0;
    flex-direction: row;
    align-items: center;
    gap: ${spacing(1)};
  }

  .policy-feedback-button.no-border {
    width: ${spacing(8)};
    min-width: ${spacing(8)};
    height: ${spacing(8)};
    min-height: ${spacing(8)};
    padding: ${spacing(2)};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${spacing(1)};
    color: ${tag_colorTagNewText};
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: ${cornerRadius};
    box-shadow: none;

    svg {
      width: ${spacing(4)};
      height: ${spacing(4)};
      flex-shrink: 0;
    }

    &:hover {
      background-color: ${base_contentHover};
      border-color: ${base_colorContentBorder};
      box-shadow: none;
      color: ${tag_colorTagNewTextHover};
    }

    &.selected {
      background-color: ${base_contentHover};
      border-color: ${base_colorContentBorder};
      box-shadow: none;
      color: ${tag_colorTagNewTextHover};
    }

    &:disabled {
      opacity: 1;
      cursor: not-allowed;

      &:hover {
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
        color: ${tag_colorTagNewText};
      }

      &.selected,
      &.selected:hover {
        background-color: ${base_contentHover};
        border-color: ${base_colorContentBorder};
        box-shadow: none;
        color: ${tag_colorTagNewTextHover};
      }
    }
  }
`

export const iconStyle = css`
  width: ${spacing(5)};
  height: ${spacing(5)};
`
